export const route_from = (state) => state.route_from

export const loading_activities = (state) => state.loading_activities
